var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table mb-0 table-hover"},[_c('tbody',_vm._l((_vm.registrationCategories),function(registrationCategory){return _c('row',{attrs:{"registration-category":registrationCategory}})}),1)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f8d65b0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Assets/components/RegistrationCategories/Tickets/Table/TableContainer.vue
// module id = 2086
// module chunks = 1